import { ClaimListResponse } from '@/modules/insurers/claims/services/apiValidation/claimListApiValidation.ts'
import { ClaimDetailResponse } from '@/modules/insurers/claims/services/apiValidation/claimDetailApiValidation.ts'

export const claimsPage1: { data: ClaimListResponse } = {
  data: {
    results: [
      {
        id: '55',
        status: 'PENDING',
        type: 'pantalla',
        workOrder: '12345',
        documentFile: '344c14fb-e210-44d2-914f-c4a7cef914a7.pdf',
        imageFile: '932db53a-bcf9-4858-a68b-cf4bc9f7c26f.png',
        workOrderFile: '65961453-1016-46d2-a9a0-cc9ae1629e12.pdf',
        createdAt: '27/04/2026',
        completedAt: null,
        insuranceId: '1',
        policyNumber: 'POL-001',
        workshopId: '162',
        workshopName: '[ MJN ] - MOJAN',
        clientId: '629',
        clientName: 'Nombre_95006',
        clientLastName: 'Apellido_95006',
        clientDocumentNumber: '55555555',
        clientPhone: '0900095006',
        clientEmail: 'albarosuarez02@gmail.com',
        registerNumber: '3876306',
        imei: '352356783566748',
        brandName: 'APPLE',
        modelName: 'TABLE 8',
        commercialAllyName: 'Ally_210'
      },
      {
        id: '56',
        status: 'COMPLETED',
        type: 'bateria',
        workOrder: '12346',
        documentFile: '444c14fb-e210-44d2-914f-c4a7cef914a8.pdf',
        imageFile: '032db53a-bcf9-4858-a68b-cf4bc9f7c26f.png',
        workOrderFile: '75961453-1016-46d2-a9a0-cc9ae1629e13.pdf',
        createdAt: '28/04/2026',
        completedAt: '30/04/2026',
        insuranceId: '1',
        policyNumber: 'POL-002',
        workshopId: '163',
        workshopName: '[ ABC ] - ABC TALLER',
        clientId: '630',
        clientName: 'Juan',
        clientLastName: 'Pérez',
        clientDocumentNumber: '66666666',
        clientPhone: '0900012345',
        clientEmail: 'juan.perez@gmail.com',
        registerNumber: '3876307',
        imei: '352356783566749',
        brandName: 'SAMSUNG',
        modelName: 'A54',
        commercialAllyName: 'Ally_211'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}

export const claimDetail55: { data: ClaimDetailResponse } = {
  data: {
    client: {
      clientId: 629,
      name: 'Nombre_95006',
      lastName: 'Apellido_95006',
      documentNumber: '55555555',
      documentType: null,
      phone: '0900095006',
      email: 'albarosuarez02@gmail.com',
      city: 'Puerto Ayacucho',
      address: 'Venezuela, Distrito Capital'
    },
    credit: {
      creditId: 688,
      registerNumber: '3876306',
      cost: '75.00',
      totalPayment: '66.00',
      imei: '352356783566748',
      dayCreditBegan: '15/12/2023',
      brand: 'APPLE',
      model: 'TABLE 8'
    },
    insurance: {
      id: 52,
      isActive: true,
      createAt: '12/03/2026',
      endDate: '12/03/2027'
    },
    workshop: {
      workshopId: '162',
      name: '[ MJN ] - MOJAN',
      address: 'Calle 24 entre Av 3 y 4, Casco Central',
      commercialAllyName: 'Ally_210'
    },
    claim: {
      insuranceClaimId: 55,
      type: 'pantalla',
      status: 'PENDING',
      createAt: '27/04/2026',
      updateAt: null,
      city: null,
      address: null,
      color: null,
      incidentDate: null,
      incidentTime: null,
      incidentPlace: null,
      incidentDescription: null,
      additionalDescription: null,
      repairComment: null,
      rejectionReason: null,
      workOrderNumber: 'ALLYID_210-162-1',
      alternativePhone: null,
      alternativeEmail: null,
      documentFile: '344c14fb-e210-44d2-914f-c4a7cef914a7.pdf',
      imageFile: '932db53a-bcf9-4858-a68b-cf4bc9f7c26f.png',
      workOrderFile: '65961453-1016-46d2-a9a0-cc9ae1629e12.pdf',
      theftDenunciaFile: null,
      theftDeclaracionFile: null
    }
  }
}

export const claimDetail56: { data: ClaimDetailResponse } = {
  data: {
    client: {
      clientId: 630,
      name: 'Juan',
      lastName: 'Pérez',
      documentNumber: '66666666',
      documentType: null,
      phone: '0900012345',
      email: 'juan.perez@gmail.com',
      city: null,
      address: null
    },
    credit: {
      creditId: 689,
      registerNumber: '3876307',
      cost: '120.00',
      totalPayment: '100.00',
      imei: '352356783566749',
      dayCreditBegan: '10/01/2024',
      brand: 'SAMSUNG',
      model: 'A54'
    },
    insurance: {
      id: 53,
      isActive: true,
      createAt: '05/02/2026',
      endDate: '05/02/2027'
    },
    workshop: {
      workshopId: '163',
      name: '[ ABC ] - ABC TALLER',
      address: 'Av. Principal, Local 3',
      commercialAllyName: 'Ally_211'
    },
    claim: {
      insuranceClaimId: 56,
      type: 'bateria',
      status: 'COMPLETED',
      createAt: '28/04/2026',
      updateAt: '30/04/2026',
      city: 'Caracas',
      address: 'Av. Libertador',
      color: 'Negro',
      incidentDate: '27/04/2026',
      incidentTime: '14:30',
      incidentPlace: 'Casa del cliente',
      incidentDescription: 'La batería dejó de cargar repentinamente.',
      additionalDescription: null,
      repairComment: 'Se reemplazó la batería.',
      rejectionReason: null,
      workOrderNumber: 'ALLYID_211-163-1',
      alternativePhone: null,
      alternativeEmail: null,
      documentFile: '444c14fb-e210-44d2-914f-c4a7cef914a8.pdf',
      imageFile: '032db53a-bcf9-4858-a68b-cf4bc9f7c26f.png',
      workOrderFile: '75961453-1016-46d2-a9a0-cc9ae1629e13.pdf',
      theftDenunciaFile: null,
      theftDeclaracionFile: null
    }
  }
}

export const claimsExportCsv =
  'ID Reclamo;Tipo;Estado;Fecha Creación;Cédula;Nombre Cliente;Teléfono;Email;IMEI;Marca/Modelo;Taller;Aliado Comercial;Nro Registro\n' +
  '55;pantalla;PENDING;27/04/2026;55555555;Nombre_95006 Apellido_95006;0900095006;albarosuarez02@gmail.com;352356783566748;APPLE TABLE 8;[ MJN ] - MOJAN;Ally_210;3876306'
